import React from 'react';
import { Layout } from 'antd';
import Navbar from '../../../components/layout/navbar/Navbar';
import { Outlet } from 'react-router-dom';
import Breadcrumb from '../../../components/common/breadcrumb/Breadcrumb';
import AdminSidebar from '../../../components/layout/sidebar/AdminSidebar';
const { Content } = Layout;

function DashboardOutlet() {
  return (
    <div>
      <Layout>
        <Navbar />
        <Layout>
          <AdminSidebar />
          <Content className="bg-[#EAF5FF] p-[20px]">
            <Breadcrumb />   
            <Outlet /> 
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default DashboardOutlet;
